import { Table  } from 'reactstrap'

export default function StatsTable(props) {
  console.log('StatsTable rendered: ', props)
  const { statisticHistory } = props

  const rows = []
  for (let row of statisticHistory) {
    rows.push(
      <tr key={row.statisticName}>
        <td>{row.statisticName}</td>
        <td style={{ textAlign: 'right' }}>{row.count}</td>
      </tr>
    )
  }
  return (
    <Table bordered size="sm" style={{ width: 'auto' }}>
      <thead>
        <tr>
          <th>Statisitic</th>
          <th>Count</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </Table>
  )
}
